<div class="grid-container">
  <div class="element"></div>
  <div class="padding-top"><input [(ngModel)]="spacing.padding.top" type="number"></div>
  <div class="padding-left"><input [(ngModel)]="spacing.padding.left" type="number"></div>
  <div class="padding-right"><input [(ngModel)]="spacing.padding.right" type="number"></div>
  <div class="padding-bottom"><input [(ngModel)]="spacing.padding.bottom" type="number"></div>
  <div class="border-bottom"><input [(ngModel)]="spacing.border.bottom" type="number"></div>
  <div class="border-top"><input [(ngModel)]="spacing.border.top" type="number"></div>
  <div class="margin-top"><input [(ngModel)]="spacing.margin.top" type="number"></div>
  <div class="margin-bottom"><input [(ngModel)]="spacing.margin.bottom" type="number"></div>
  <div class="border-left"><input [(ngModel)]="spacing.border.left" type="number"></div>
  <div class="margin-left"><input [(ngModel)]="spacing.margin.left" type="number"></div>
  <div class="border-right"><input [(ngModel)]="spacing.border.right" type="number"></div>
  <div class="margin-right"><input [(ngModel)]="spacing.margin.right" type="number"></div>
  <div class="padding-text">padding</div>
  <div class="border-text">border</div>
  <div class="margin-text">margin</div>
  <div class="padding"></div>
  <div class="border"></div>
  <div class="margin"></div>
</div>
